import { motion } from 'framer-motion';
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import SectionWrapper from '../ui/SectionWrapper';

const contactMethods = [
    {
        id: 'email',
        icon: FaEnvelope,
        label: 'Email',
        value: 'cheovariionut@yahoo.com',
        href: 'mailto:cheovariionut@yahoo.com',
        ariaLabel: 'Send email to cheovariionut@yahoo.com',
    },
    {
        id: 'whatsapp',
        icon: FaWhatsapp,
        label: 'WhatsApp',
        value: 'Chat on WhatsApp',
        href: 'https://wa.me/40752353641',
        ariaLabel: 'Start a WhatsApp conversation',
    },
    {
        id: 'address',
        icon: FaMapMarkerAlt,
        label: 'Address',
        value: 'Gospodarilor 11a, Cluj-Napoca',
        href: null,
        ariaLabel: null,
    },
];

const Contact = () => {
    return (
        <SectionWrapper id="contact" className="bg-bg-secondary/30">
            <motion.div
                className="max-w-2xl mx-auto text-center"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
                    <span className="text-gradient">Get in Touch</span>
                </h2>

                <p className="text-text-secondary mb-12">
                    Feel free to reach out through any of the channels below.
                </p>

                <div className="space-y-6">
                    {contactMethods.map((method, index) => (
                        <motion.div
                            key={method.id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            {method.href ? (
                                <a
                                    href={method.href}
                                    target={method.id === 'whatsapp' ? '_blank' : undefined}
                                    rel={method.id === 'whatsapp' ? 'noopener noreferrer' : undefined}
                                    aria-label={method.ariaLabel}
                                    className="glass glass-hover flex items-center gap-4 p-5 rounded-[12px] group cursor-pointer"
                                >
                                    <span className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-r from-accent-blue to-accent-gold text-white flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                                        <method.icon className="w-5 h-5" />
                                    </span>
                                    <div className="text-left">
                                        <p className="text-sm text-text-muted uppercase tracking-wider mb-1">
                                            {method.label}
                                        </p>
                                        <p className="text-text-primary font-medium group-hover:text-accent-blue transition-colors duration-300">
                                            {method.value}
                                        </p>
                                    </div>
                                </a>
                            ) : (
                                <div
                                    className="glass flex items-center gap-4 p-5 rounded-[12px]"
                                >
                                    <span className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-r from-accent-blue to-accent-gold text-white flex-shrink-0">
                                        <method.icon className="w-5 h-5" />
                                    </span>
                                    <div className="text-left">
                                        <p className="text-sm text-text-muted uppercase tracking-wider mb-1">
                                            {method.label}
                                        </p>
                                        <p className="text-text-primary font-medium">
                                            {method.value}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </SectionWrapper>
    );
};

export default Contact;
